import { Injectable } from '@angular/core';
import { RaintreeResponse } from '../interfaces/raintree-response';
import { ApiService } from '../../common/api.service';
import { Observable } from 'rxjs';
import { ROUTES } from '../../server-route';
import { GlobalResponseData, ReportStatus } from '../interfaces/global-respo';
import { FCMergeResponse } from '../interfaces/fc-merge.interface';

@Injectable({
  providedIn: 'root',
})
export class MergeFCService extends ApiService {
  public fetchDataBySlNo(reqData: any): Observable<FCMergeResponse> {
    return this.get<FCMergeResponse>(
      this.replacePathInfo(ROUTES.FC_MERGE_BY_SL, {
        memKey: reqData,
      })
    );
  }

  public addForMerge(key: any, reqData: any): Observable<any> {
    return this.post<any>(
      this.replacePathInfo(ROUTES.ADD_FOR_MERGE, {
        memKey: key,
      }),
      {
        body: reqData,
      }
    );
  }
  public fetchMergeHistory(): Observable<any> {
    return this.get<any>(ROUTES.MERGE_HISTORY);
  }
}
